import formRules from '@/config/rules';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      formRules,
    };
  },
  components: {},
  computed: {
    ...mapGetters(['showVideoUpload', 'uploadVideoList']),
  },
  methods: {
    showVideoUploader() {
      this.$store.commit('UPDATE_SHOW_VIDEO_UPLOAD', true);
    },
  },
};
